export const applyWatercolorEffect = async (canvas, ctx, setMessage, language) => {
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 수채화 효과: 색상 번짐과 투명감
  // 1. 색상 채도 감소 (수채화의 부드러운 느낌)
  for (let i = 0; i < data.length; i += 4) {
    const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
    // 채도를 줄여서 부드러운 느낌 연출
    data[i] = avg + (data[i] - avg) * 0.7;
    data[i + 1] = avg + (data[i + 1] - avg) * 0.7;
    data[i + 2] = avg + (data[i + 2] - avg) * 0.7;
    
    // 전체적으로 약간 밝게 (수채화의 투명감)
    data[i] = Math.min(255, data[i] * 1.1 + 20);
    data[i + 1] = Math.min(255, data[i + 1] * 1.1 + 20);
    data[i + 2] = Math.min(255, data[i + 2] * 1.1 + 20);
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 블러링 효과 (물 번짐 시뮬레이션)
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  // 가우시안 블러 시뮬레이션
  const blurData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const blurPixels = blurData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  const blurRadius = 2;
  for (let y = blurRadius; y < canvas.height - blurRadius; y++) {
    for (let x = blurRadius; x < canvas.width - blurRadius; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        let sum = 0;
        let count = 0;
        
        // 주변 픽셀들의 가중 평균
        for (let dy = -blurRadius; dy <= blurRadius; dy++) {
          for (let dx = -blurRadius; dx <= blurRadius; dx++) {
            const distance = Math.sqrt(dx * dx + dy * dy);
            if (distance <= blurRadius) {
              const weight = Math.exp(-(distance * distance) / (2 * blurRadius * blurRadius));
              const neighborPos = ((y + dy) * canvas.width + (x + dx)) * 4;
              sum += tempData[neighborPos + c] * weight;
              count += weight;
            }
          }
        }
        
        blurPixels[pos + c] = sum / count;
      }
    }
  }
  
  ctx.putImageData(blurData, 0, 0);
  
  // 3. 종이 질감 효과
  const textureData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const texturePixels = textureData.data;
  
  for (let i = 0; i < texturePixels.length; i += 4) {
    // 수채화 종이의 거친 질감 시뮬레이션
    if (Math.random() > 0.95) {
      const textureAmount = (Math.random() - 0.5) * 25;
      for (let c = 0; c < 3; c++) {
        texturePixels[i + c] = Math.min(255, Math.max(0, texturePixels[i + c] + textureAmount));
      }
    }
  }
  
  ctx.putImageData(textureData, 0, 0);
};